module.exports = __webpack_public_path__ + "d2c16a0ab418634c6289bc24c3e142bd.svg";